import { render, staticRenderFns } from "./navList2.vue?vue&type=template&id=45e62e48&scoped=true&"
import script from "./navList2.vue?vue&type=script&lang=js&"
export * from "./navList2.vue?vue&type=script&lang=js&"
import style0 from "./navList2.vue?vue&type=style&index=0&id=45e62e48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e62e48",
  null
  
)

export default component.exports